<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="exibir == true">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between pt-4"
      >
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{ itens.length }} de {{ qtdTotal }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <vs-card class="showMobile">
        <vs-pagination
          :max="screenWidth < 650 ? 5 : 9"
          v-if="qtdPaginas > 1"
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </vs-card>

      <vs-card v-if="!qtdPaginas" class="flex justify-center p-4">
        <h4 class="mt-2">Nenhum Segurado Encontrado</h4>
      </vs-card>

      <div v-for="item in itens" :key="item.id">
        <div class="relative">
          <vs-card>
            <div class="vx-row">
              <div class="vx-col flex w-full justify-between">
                <div class="flex w-full justify-between mr-2 ml-2">
                  <div class="vx-col flex gap-1 mt-2 mb-4">
                    <vs-chip class="divIdProposta rounded" color="#078fcf"
                      >{{ item.id_prospect }}
                    </vs-chip>
                    <vs-chip
                      class="divIdProposta rounded"
                      color="#2b50bb"
                      data-testid="product-tag"
                      >{{ getProductTagText(item.policyType) }}
                    </vs-chip>
                    <vs-chip
                      :color="getStatusColor(item.situacao)"
                      class="divIdProposta rounded"
                    >
                      {{ getStatusString(item.situacao) }}
                    </vs-chip>
                    <vs-chip
                      class="divIdProposta rounded"
                      v-if="!vistoria"
                      color="#078fcf"
                    >
                      APÓLICE {{ item.policyNumber }}
                    </vs-chip>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:flex lg:justify-between ml-2">
                <div class="gap-3 mb-4 lg:w-full mr-2">
                  <div class="divSubTitle">
                    {{ item.nome }}
                  </div>
                  <div class="divInfo">{{ item.tipo }}</div>
                </div>

                <div class="gap-3 mb-4 lg:w-full mr-2">
                  <div v-if="item.dataAtivacao" class="sm:block flex gap-2">
                    <p class="divTitle">DATA DE ATIVAÇÃO</p>
                    <div class="divInfo">
                      {{ functions.formatDateAndHour(item.dataAtivacao) }}
                    </div>
                  </div>
                  <div v-else class="lg:block flex gap-2">
                    <p class="divTitle">DATA DE CRIAÇÃO</p>
                    <div class="divInfo">
                      {{ functions.formatDateAndHour(item.createdAt) }}
                    </div>
                  </div>
                </div>

                <div class="gap-2 mb-4 lg:block flex lg:w-full mr-2">
                  <p class="divTitle">CORRETORA/ASSESORIA</p>
                  <div class="divInfo">
                    <div>{{ item.regional }}</div>
                    <div>{{ item.nome_divisao }}</div>
                  </div>
                </div>

                <div class="gap-2 mb-4 lg:block flex lg:w-full mr-2">
                  <p class="divTitle">CIDADE/UF</p>
                  <div class="divInfo">
                    {{ item.cidade }} / {{ item.estado }}
                  </div>
                </div>

                <div
                  class="vx-col mr-2"
                  v-if="
                    $can($actionsDefault.Escrita, subjectPermission) ||
                    $can($actionsDefault.Leitura, subjectPermission)
                  "
                >
                  <a
                    v-tooltip="'Ver detalhes do Segurado'"
                    :href="`/DetalheSegurado/${item.id_prospect}`"
                    class="vs-button vs-button-primary vs-button-gradient includeIcon includeIconOnly vs-radius text-white"
                  >
                    <i class="feather icon-search"></i>
                  </a>
                </div>
              </div>
            </div>
          </vs-card>
        </div>
      </div>

      <vs-card>
        <vs-pagination
          :max="screenWidth < 650 ? 5 : 9"
          v-if="qtdPaginas"
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </vs-card>
      <!------------ END Proposta ------------>

      <!------------ START INFORMAÇÕES DO Proposta ------------>
    </div>
    <div v-else>
      <vs-alert
        color="warning"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        É Necessário fazer um filtro para exibir os Segurados, (clique em
        buscar)
      </vs-alert>
    </div>
    <!------------ END INFORMAÇÕES DO Proposta ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import service from '../../services';
import moment from 'moment';
import jwt from 'jsonwebtoken';
import functions from '../../utils/functions.js';
import { PRODUCT_TAG } from '../../constants/tipo.apolice';

export default {
  components: {},
  props: ['filtro', 'realizaFiltro', 'vistoria', 'subjectPermission'],
  watch: {
    realizaFiltro: function (newValue) {
      if (newValue == true) {
        this.buscaDados();
        this.$emit('filtroOk', true);
      }
    },
    paginaAtual: function () {
      this.buscaDados();
    },
    itemsPerPage: function () {
      this.buscaDados();
    },
  },
  data() {
    return {
      chave: 0,
      isAdmin: false,
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: 'Proposta',
      formSideBar: 'Proposta',
      entidade: 'Proposta',
      titleSideBar: 'Adicionar Proposta',
      popupActive: false,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 50,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
      exibir: false,
      regionais: [],
      regionaisUsuarios: [],
      regionalDefault: [],
      usuarios_regionais: [],
      idRegionais: [],
      regionaisUsuario: [],
      screenWidth: null,
      functions,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    getProductTagText(id) {
      return PRODUCT_TAG[id];
    },
    verificaAdmin() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == 'Super User') this.isAdmin = true;
      }
      const decoded = jwt.decode(token);
      this.id_usuario = decoded.id_usuario;
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        // this.idEmpresa = this.decoded.id_empresa;
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    somaValorTotalMes(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal == true) total = total + element.valorFinal;
      });
      return total;
    },
    calculaQtddeDiasEnviada(status, date) {
      var a = moment();
      var horas = a.diff(date, 'hours');
      return horas + 'h aguardando';
    },
    getStatusColorHoras(status, date) {
      var a = moment();
      var horas = a.diff(date, 'hours');
      if (horas < 10) return 'success';
      if (horas >= 10 && horas <= 24) return 'warning';
      if (horas > 24) return 'danger';
    },

    somaValorTotal(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal != true) total = total + element.valorFinal;
      });
      return total;
    },
    closePop() {
      this.popupActive = false;
    },
    closeSideBar() {
      this.addNewDataSidebar = false;
      this.chave++;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    buscaDados() {
      this.filtred = true;
      this.selected = [];
      this.$vs.loading();
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
      }

      if (this.filtro) {
        if (this.filtro.regional) {
          objSend.regional = this.filtro.regional.map((item) => item.id);
        }
        if (this.filtro.consultor) {
          objSend.consultor = this.filtro.consultor.map((item) => item.id);
        }
      } else {
        objSend.regional = this.idRegionais;
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;

      service
        .post('Associado', 'listarAssociadosFiltro', objSend)
        .then((res) => {
          this.exibir = true;
          this.itens = [];
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.associados.forEach((element) => {
              this.itens.push(element);
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaRegionais() {
      this.$vs.loading();
      service
        .getAll(
          'Usuario',
          {},
          `list/idEmpresa=${this.idEmpresa}?idUsuario=${this.id_usuario}`,
        )
        .then((res) => {
          this.$vs.loading.close();
          res.data.forEach((element) => {
            if (element.idUsuario == this.id_usuario) {
              if (element.usuarios_regionais.length > 0) {
                this.usuarios_regionais = element.usuarios_regionais;
                this.usuarios_regionais.forEach((elementSel) => {
                  this.regionaisUsuario.push({
                    id: elementSel.id_regional,
                    label: elementSel.nome,
                  });
                });
                this.regionais = this.regionaisUsuario.concat(
                  this.regionalDefault,
                );
                this.idRegionais = this.regionais.map((item) => item.id);
              } else {
                var usuarios_regionais = element.Usuarios_Regional;
                this.regionais.push({
                  id: usuarios_regionais.idRegional,
                  label: usuarios_regionais.nome,
                });
                this.idRegionais = this.regionais.map((item) => item.id);
              }
            }
          });
          this.buscaDados();
        });
    },
    openSideBar(dados) {
      dados.idProposta == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    concluido() {
      this.chave++;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == 'ATIVO') return 'success';
      if (data == null) return 'warning';
      if (data == 'INADIMPLENTE') return 'danger';
      if (data == 'Pendente') return 'bg-blue';
      if (data == 'Finalizada') return 'dark';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Prospect';
      return data;
    },
  },
  created() {},
  mounted() {
    this.getDecoded();
    //this.buscaDados();
    this.verificaAdmin();
    this.isMounted = true;
    this.screenWidth = window.innerWidth;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style scoped src="../../assets/css/listCard.css"></style>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}
</style>

<!------------ END STYLE ------------>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
